import {colorArr} from "./color-util.js";

let colorfulNodes = function (ctx) {
    let {nodes} = ctx.data;
    let groupColorMap = {};
    let colorIndex = 0;

    nodes.forEach(_ => groupColorMap[_.id] = null);

    nodes.forEach((_, i) => {
        // let group = _.group || _.id;
        let group = _.rootId || _.id;

        if (!groupColorMap[group]) {
            let currentGroupColor = colorArr[colorIndex % colorArr.length];
            _[ctx.colorKey] = currentGroupColor;
            groupColorMap[group] = currentGroupColor;
            colorIndex++;
        } else {
            _[ctx.colorKey] = groupColorMap[group];
        }

        // 特殊规则

        if (_.id === ctx.rootId) { // 根节点
            _[ctx.colorKey] = '#26aba2';
        } else if (_.depth === '1' && _.rootId === ctx.rootId) { // 根节点标签

        } else if (_.rootId === ctx.rootId) { // 根节点组其他

        } else if (_.depth === '0') { // POI节点
            _[ctx.colorKey] = '#38B0D7';
        }
    });
}

// 修复数据
let fixData = function (ctx) {
    ctx.data.nodes.forEach(n => {
        if (n.depth === '0') {
            // n.fx = 0;
            // n.fy = 0;
            // n.fz = 0;
        }
    });
    ctx.data.links.forEach(n => {
        // n.curvature = .3;
        // n.rotation = .3;
    });
};

let commonSet = (arr1, arr2) => {
    return arr1.filter(v => arr2.includes(v))
};

let commonNode = function (ctx) {
    let {nodes, links} = ctx.data;
    if (nodes.length === 0 || links.length === 0) {
        return;
    }
    let poiIds = [];
    let poiMap = {};

    nodes.forEach(node => {
        if (node && node.depth === '0') {
            poiMap[node.id] = true;
            poiIds.push(node.id);
        }
    });

    // 获取和我相连接的节点
    let getLinkedNodeIds = (id) => {
        let tmpLinkNodes = [];
        links.forEach((link) => {
            if (link && link.source === id) {
                tmpLinkNodes.push(link.target);
            }
            if (link && link.target === id) {
                tmpLinkNodes.push(link.source);
            }
        });
        tmpLinkNodes = Array.from(new Set(tmpLinkNodes));
        return tmpLinkNodes;
    };

    // 根据节点id获取节点
    let getNodeById = id => nodes.find(node => node && node.id === id);

    // 与POI直接相连接的节点
    let poiDirectNodeIds = [];
    links.forEach((link) => {
        if (link) {
            let sourceNode = getNodeById(link.source);
            let targetNode = getNodeById(link.target);
            if (sourceNode && sourceNode.depth === '0') {
                poiDirectNodeIds.push(link.target);
            }
            if (targetNode && targetNode.depth === '0') {
                poiDirectNodeIds.push(link.source);
            }
        }

    });

    let coreNodeIds = [...poiDirectNodeIds, ...poiIds];

    let allShowNodeIds = [];
    let otherNodes = nodes.filter(node => node && node.depth !== '0' && !poiDirectNodeIds.includes(node.id));
    otherNodes = nodes.filter(node => node && node.depth !== '0');
    // otherNodes = nodes.filter(node => node.depth === '2');
    otherNodes.forEach((node) => {
        if (node) {
            let linkedNodeIds = getLinkedNodeIds(node.id);
            if (linkedNodeIds.length >= 2) {
                let commonNode = commonSet(linkedNodeIds, coreNodeIds);
                if (commonNode.length >= 2) {
                    allShowNodeIds = [...allShowNodeIds, ...commonNode, node.id];
                }
            }
        }

    });


    allShowNodeIds = [...allShowNodeIds, ...poiIds];
    nodes.forEach(node => {
        if (node && allShowNodeIds.includes(node.id)) {
            node.isCommonRoute = true;
        }
    });

    // ctx.data.nodes = ctx.data.nodes.filter(_ => allShowNodeIds.includes(_.id));
    // ctx.data.links = ctx.data.links.filter(link => {
    //     if (allShowNodeIds.includes(link.source) && allShowNodeIds.includes(link.target)) {
    //         return true;
    //     }
    // });
};

let processData = function (ctx) {
    fixData.call(this, this);
    colorfulNodes.call(this, this);
    commonNode.call(this, this);
};

export default processData;
